import { DatePicker, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import helper from "../../../../helper/helper";
import { emptyIoPagination, IoPagination } from "../../../../helper/pagination";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import {
  CustomerRequest,
  CustomerRequestFilter,
} from "../entity/customer-request.model";
import { customerRequestService } from "../service/customer-request.service";
import CustomerRequestTable from "./CustomerRequestTable";

function CustomerRequests() {
  const { Option } = Select;
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [customerRequests, setCustomerRequests] = useState<
    IoPagination<CustomerRequest>
  >({
    totalElements: 1,
    content: [],
  });

  const [customerRequestFilter, setCustomerRequestFilter] =
    useState<CustomerRequestFilter>({
      page: 1,
      pageSize: 10,
    });

  const pageChange = (inquiry: CustomerRequestFilter) => {
    dispatch({ type: spinActions.BLOCK });

    if (state.routeId.length > 0) {
      inquiry.customerRouteId = state.routeId;
    } else {
      inquiry.customerRouteId = undefined;
    }

    customerRequestService
      .getCustomerRequests(inquiry)
      .then((pagination: IoPagination<CustomerRequest>) => {
        customerRequests.current = inquiry.page;
        setCustomerRequests(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });

    return () => {
      setCustomerRequests(emptyIoPagination);
    };
  };

  useEffect(() => {
    pageChange(customerRequestFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  return (
    <>
      <MPageHeader crumbs={["Харилцагчийн бүртгэлийн хүсэлтүүд"]} />

      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Харилцагчийн бүртгэл</h6>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <DebounceSelect<UserUI>
                showSearch
                allowClear
                placeholder="Үүсгэсэн ажилтан"
                onChange={(value) => {
                  setCustomerRequestFilter({
                    ...customerRequestFilter,
                    createdBy: value?.username,
                  });
                }}
                fetchOptions={(search) => {
                  return userService.getUsers(search, state.routeId);
                }}
                style={{ maxWidth: "calc(100% - 91px)", width: "250px" }}
              />

              <Input
                className="ml-2"
                placeholder="Нэр"
                onChange={(e) => {
                  setCustomerRequestFilter({
                    ...customerRequestFilter,
                    name: e.target.value,
                  });
                }}
                style={{ width: 150 }}
              />

              <DatePicker
                className="ml-2"
                placeholder="Огноо"
                onChange={(date, dateString) => {
                  setCustomerRequestFilter({
                    ...customerRequestFilter,
                    createdDate: dateString,
                  });
                }}
                style={{ width: 200 }}
              />

              <Select
                className="ml-2"
                placeholder="Төрөл сонгох"
                allowClear
                onChange={(value) => {
                  setCustomerRequestFilter({
                    ...customerRequestFilter,
                    customerRequestType: value,
                  });
                }}
                style={{ width: 200 }}
              >
                <Option value="ADD">
                  {helper.getCustomerRequestType("ADD")}
                </Option>
                <Option value="UPDATE">
                  {helper.getCustomerRequestType("UPDATE")}
                </Option>
              </Select>

              <Select
                className="ml-2"
                placeholder="Төлөв сонгох"
                allowClear
                onChange={(value) => {
                  setCustomerRequestFilter({
                    ...customerRequestFilter,
                    status: value,
                  });
                }}
                style={{ width: 200 }}
              >
                <Option value="NEW">Шинэ</Option>
                <Option value="CANCELLED">Цуцласан</Option>
                <Option value="APPROVED">Зөвшөөрсөн</Option>
              </Select>
            </div>

            <button
              type="button"
              className="btn btn-sm btn-primary mt-1 mb-2"
              onClick={() => {
                let _customerRequestFilter = {
                  ...customerRequestFilter,
                  page: 1,
                  pageSize: 10,
                };

                pageChange(_customerRequestFilter);
              }}
            >
              <i className="icon-search4 mr-2" />
              Хайх
            </button>
            <CustomerRequestTable
              pagination={customerRequests}
              onChange={(page: number, pageSize: number) => {
                pageChange({ page, pageSize });
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerRequests;
